export enum ComponentId {
  DESCRIPTION = "description",
  ADDITIONAL_IMAGES = "ocPropertyDamages",
  DAMAGE_IMAGES = "ocPropertyDamages",
}
